import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/medication-manager/components/MedicationManagerInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Sidebar.tsx");
